"use client";
import { useEffect, useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import Header from "./Header";
import { UserSidebar } from "./UserSidebar";
import { SidebarProvider, SidebarInset } from "./ui/sidebar";

export default function UserLayout({
  children,
}) {
  const { isAuthenticated, hasRole, loading } = useAuth();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {    
    if (loading) {
      return;
    }
    
    if (!isAuthenticated() || (!hasRole('customer') && !hasRole('user'))) {
      window.location.href = "/login";
    } else {
      setMounted(true);
    }
  }, [isAuthenticated, hasRole, loading]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="relative">
          <div className="w-20 h-20 border-4 border-muted border-t-primary rounded-full animate-spin"></div>
        </div>
      </div>
    );
  }

  if (!mounted) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="w-20 h-20 border-4 border-muted border-t-primary rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-muted-foreground">Loading dashboard...</p>
        </div>
      </div>
    );
  }

  return (
    <SidebarProvider>
      <UserSidebar />
      <SidebarInset className="min-w-0 max-w-full overflow-x-hidden">
        <Header />
        <div className="app-page flex flex-1 flex-col gap-3 md:gap-4 pt-0 pb-4 md:pb-6 min-w-0">
          {children}
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
}
